<template>
	<v-chip color="#FCF5F8" text-color="#e95d65" x-small label class="pointer-events-none">Required</v-chip>
</template>

<script>
export default {
	name: 'RequiredChip',
};
</script>

<style lang="scss" scoped></style>
